import DependentsPage from "./DependentsPage";

export default DependentsPage;
